import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';
import slide1 from '../../assets/images/slide1.jpg';
import slide2 from '../../assets/images/slide2.jpg';

const Hero = () => {
  const { t, i18n } = useTranslation();
const currentLang = i18n.language;
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: t('hero.slide1.title'),
      description: t('hero.slide1.description'),
      buttonText: t('hero.buttonText'),
      buttonLink: "#about",
      image: slide1
    },
    {
      title: t('hero.slide2.title'),
      description: t('hero.slide2.description'),
      buttonText: t('hero.buttonText'),
      buttonLink: "#about",
      image: slide2
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section id="home" className="hero-section">
      
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div 
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${slide.image})`
            }}
          >
            <div className="overlay" />
        <div className='section-container'>
            <div className={`slide-content ${i18n.language === 'en' ? 'en-font-adjust' : ''}`}>
              <h1>{slide.title}</h1>
              <p>{slide.description}</p>
              <a href={slide.buttonLink} className="hero-button">
                {slide.buttonText}
              </a>
            </div>
            </div>
          </div>
        ))}
      </div>
      
      {currentLang === 'ar' ? (
  <>
    <button className="slider-arrow next" onClick={goToNextSlide}>
      &#x2039; {/* ← */}
    </button>
    <button className="slider-arrow prev" onClick={goToPrevSlide}>
      &#x203A; {/* → */}
    </button>
  </>
) : (
  <>
    <button className="slider-arrow prev" onClick={goToPrevSlide}>
      &#x2039; {/* ← */}
    </button>
    <button className="slider-arrow next" onClick={goToNextSlide}>
      &#x203A; {/* → */}
    </button>
  </>
)}

      
      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
      
    </section>
  );
};

export default Hero;